import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

import { McRAIStepLabel } from '../../directives/step-label.directive';

@Component({
  selector: 'mcrai-step-header',
  template: `<button class="mcrai-step-header__label" mcrai-button [disabled]="isActive()">
  <div class="mcrai-step-header__label-container">
    {{ getStringIndex() }}
    <ng-container *ngIf="getTemplateLabel()" [ngTemplateOutlet]="getTemplateLabel().template"></ng-container>
    <ng-container *ngIf="getStringLabel()">{{ getStringLabel() }}</ng-container>
  </div>
</button>
`,
  styles: [`.mcrai-step-header{flex:0 0 auto}.mcrai-step-header__label{height:50px}.mcrai-step-header__label-container{display:flex;flex-direction:column}`]
})
export class StepHeaderComponent implements OnInit {
  @HostBinding('class.mcrai-step-header') cssClass = true;

  @Input('label') private _label: McRAIStepLabel | string;
  @Input('index') private _index: number;
  @Input('active') private _active: boolean;

  constructor(
    private _elRef: ElementRef,
  ) { }

  ngOnInit() { }

  public getStringLabel(): string | null {
    return this._label instanceof McRAIStepLabel ? null : this._label;
  }

  public getTemplateLabel(): McRAIStepLabel | null {
    return this._label instanceof McRAIStepLabel ? this._label : null;
  }

  public getHostElement(): Element {
    return this._elRef.nativeElement;
  }

  public getStringIndex(): string {
    return (this._index + 1) + '.';
  }

  public isActive(): boolean {
    return this._active;
  }

}
